<template>
  <ContentLayout
    :title="$t('label_essweb_site_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-site-management')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-site-management')"
    :importBtn="hasBtn('import-admin-site-management')"
    :import-options="{
      api: '/site/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/site-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, () => {
          $store.dispatch('resetTable', new Date().getTime());
        });
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="table-title text--primary"
            :title="$getCommonLangValue(item.site_name)"
          >
            {{ $getCommonLangValue(item.site_name) }}
          </div>
          <div
            class="text--secondary table-subtitle"
            :title="$getCommonLangValue(item.site_description)"
          >
            {{ $getCommonLangValue(item.site_description) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">{{
          $getCommonLangValue(item.site_abbr)
        }}</template>
        <template v-slot:item.type="{ item }">
          <div class="d-flex flex-wrap justify-start" style="max-width: 400px">
            <v-chip
              class="ma-1 table-title"
              small
              v-for="(type, index) in item.ess_site_type"
              :key="index"
              >{{ $getCommonLangValue(type.site_type_name) }}</v-chip
            >
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-site-management')"
            :editBtn="hasBtn('edit-admin-site-management')"
            :viewBtn="hasBtn('view-admin-site-management')"
            :title="$t('label_essweb_site_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
      <!-- content -->
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SiteList",
  computed: {},
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_site_list_siteNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.site_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_site_list_siteAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_site_list_siteTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          sortable: false,
          align: "end",
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_site_list_siteNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "abbr",
          position: "right",
          label: "label_essweb_site_list_siteAbbrLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "site_type_name",
          name: "site_type",
          multiple: true,
          label: "label_essweb_site_list_siteTypeLabel",
          value: [],

          selected: [],
          data: {
            api: "/site-type/get-site-type-list/",
            url_type: "primary",
            args: null,
            table: "ess_site_type",
            type: "",
            modelKey: "site_type_name",
            valueKey: "uuid",
            global: false,
          },
        },
      ],
      filterPageData: null,
    };
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["site_name"] = item.value;
        }
        if (item["name"] == "site_type") {
          data["site_type_uuid"] = item.value.join(",");
        }
        if (item["name"] == "abbr") {
          data["site_abbr"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    onExport() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["site_name"] = item.value;
        }
        if (item["name"] == "site_type") {
          data["site_type_uuid"] = item.value.join(",");
        }
        if (item["name"] == "abbr") {
          data["site_abbr"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_site_list_title"),
      });
    },
    toNew: function () {
      this.$toPage("/admin/site/add", {});
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toEdit: function (id, action) {
      this.$toPage(
        (action == "edit" ? "/admin/site/edit/" : "/admin/site/detail/") + id
      );
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/delete-site-table/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_site_list_deleteSiteSuccessLabel"),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
